// extracted by mini-css-extract-plugin
export default {"SearchInputContainer":"Polls_SearchInputContainer__uQm+1","QuestionContainer":"Polls_QuestionContainer__c5ywv","Spinner":"Polls_Spinner__gFzTg"};